module.exports = __webpack_public_path__ + "static/img/222_TO8_1946.a07d0f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/222_TO8_1946.jpg
// module id = c8VK
// module chunks = 0